export default "__VITE_ASSET__YFMaCvGj__"